import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { ButtonGroup } from "../ButtonGroup/ButtonGroup";
import { DataPanel, IDataPanelProps } from "../DataPanel/DataPanel";
import { TextBox } from "../TextBox/TextBox";

import Link = EventLibrary.Model.Link;

export interface ILinkSelectorProps extends IDataPanelProps<Link[]>
{

}

export interface ILinkControls
{
    DescriptionBox?: TextBox;
    UrlBox?: TextBox;
    TypeSelector?: ButtonGroup;
}

export class LinkSelector extends DataPanel<Link[], ILinkSelectorProps>
{
    private _linkControls: ILinkControls[];
    private _pnlLinks: HTMLElement;

    constructor(props: ILinkSelectorProps)
    {
        super(props);
        this._linkControls = [];
    }

    public override setData(data?: Link[])
    {
        this._linkControls = [];
        let links = data || [];

        this._pnlLinks.innerHTML = "";
        links.forEach((link) => 
        {
            this.addLink(link);
        })
    }

    public override getData(): Link[]
    {
        let links: Link[] = [];
        for (let linkControl of this._linkControls)
        {
            let url = linkControl.UrlBox.getValue().trim();
            if (url.length > 0)
            {
                links.push({ Url: linkControl.UrlBox.getValue(), Description: linkControl.DescriptionBox.getValue()});
            }
        }
        return links;
    }

    private _onAddLinkClick(): void
    {
        this.addLink({});
    }

    private _onPnlClick(evt): void
    {
        let target = $$.getParent(evt.target, "a", "deleteImage")
        if (target)
        {
            let container = $$.getParent(target, "div", "linkContainer");
            let index = $(container).index();
            container.remove();
            this._linkControls.splice(index, 1);
        }
    }

    private registerControl(urlBox, descriptionBox, index: number)
    {
        if (!this._linkControls[index])
        {
            this._linkControls[index] = {};
        }
        if (urlBox)
        {
            this._linkControls[index].UrlBox = urlBox;
        }
        if (descriptionBox)
        {
            this._linkControls[index].DescriptionBox = descriptionBox;
        }
    }

    public addLink(link: Link): void
    {
        this._linkControls.push({});
        let currentIndex = this._linkControls.length - 1;
        let content = (

            <div className="linkContainer" style={{ marginBottom: "10px", paddingTop: "5px" }}>
                <TextBox Descriptor="Url"
                    Value={link.Url || ""}
                    style={{ width: "220px" }}
                    ref={(ref) => this.registerControl(ref, null, currentIndex)} />
                <TextBox Descriptor="Description" style={{ marginLeft: "10px", width: "295px" }} Value={link.Description || ""}
                    ref={(ref) => this.registerControl(null, ref, currentIndex)} />


                <a href="javascript:void(0);" className="deleteImage" style={{ marginLeft: "4px" }}></a>
            </div>);
        
        $$.appendChild(this._pnlLinks, content);

    }

    public render()
    {
        return (<div className="videoSelector" ref={(ref) => this._registerContainer(ref)} >
            <label className="labelHeader">Links</label>
            <div style={{ marginTop: "5px", paddingLeft:"6px" }} ref={(ref) => this._pnlLinks = ref} onClick={this._onPnlClick.bind(this)}></div>
            <a href="javascript:void(0);" style={{ fontSize: "10pt", display: "inline-block" }} onClick={(this._onAddLinkClick as any).bind(this)}>Add Link</a>
        </div >);
    }
}